import LoadingComponent from '@/pages/components/loadingComponent'
import Loadable from 'react-loadable'

export default [
  {
    component: Loadable({
      loader: () => import('@/pages/courierProve/dalianProve/index'),
      loading: LoadingComponent
    }),
    path: '/courierView/courierProve/dalianProve',
    exact: true,
    meta: {
      title: '政府证明'
    }
  }
]
